import Browser from "./browser";

const debug = true;

export const print = (sURL) => {
        log('printing "' + sURL + '"');


    //
        // function closePrint () {
        //     document.body.removeChild(document.getElementById(id));
        //     resolve();
        // }

        // function setPrint () {
        //
        //     this.contentWindow.__container__ = this;
        //     this.contentWindow.fponprintstarted = closePrint;
        //     this.contentWindow.onbeforeunload = closePrint;
        //     this.contentWindow.onafterprint = () => {
        //         closePrint()
        //     };
        //
        //     this.contentWindow.matchMedia('print').addListener((mql) => {
        //         if (!mql.matches) {
        //             closePrint();
        //         };
        //     });
        //
        //     this.contentWindow.focus(); // Required for IE
        //
        // }



    //     document.body.appendChild(oHiddFrame);
    //
    // })

    const oHiddFrame = document.createElement("iframe");

    oHiddFrame.style.visibility = "hidden";
    oHiddFrame.style.position = "fixed";
    oHiddFrame.style.right = "0";
    oHiddFrame.style.bottom = "0";
    oHiddFrame.src = sURL;
    oHiddFrame.sandbox = 'allow-modals allow-scripts allow-same-origin';
    document.body.appendChild(oHiddFrame);

    log('iframe created', oHiddFrame);



    return new Promise((resolve) => {

        const timeoutHandle = setTimeout(() => {
            console.error('window.onprintready() not called in iframe after 10s')
            log('timeout for window.onprintready() reached, continue');
            resolve();
        }, 10000);

        oHiddFrame.contentWindow.onprintready = () => {
            clearTimeout(timeoutHandle);
            log('onprintready called, starting print')
            resolve();
        };
    }).then(() => {
        return performPrint(oHiddFrame, {});
    });
}

function performPrint (iframeElement, params) {
    log('performing print of iframe', iframeElement);

    return new Promise((resolve, reject) => {
        setTimeout(() => {
            try {
                iframeElement.focus()
                // If Edge or IE, try catch with execCommand
                if (Browser.isEdge() || Browser.isIE() || Browser.isSafari()) {
                    try {
                        iframeElement.contentWindow.document.execCommand('print', false, null)
                    } catch (e) {
                        iframeElement.contentWindow.print()
                    }
                } else {
                    // Other browsers
                    iframeElement.contentWindow.print()
                }
            } catch (error) {
                log('error during window.print call', error)

                reject();
            } finally {
                log('starting cleanup')
                if (Browser.isFirefox()) {
                    // Move the iframe element off-screen and make it invisible
                    iframeElement.style.visibility = 'hidden'
                    iframeElement.style.left = '-1px'
                }

                document.body.removeChild(iframeElement);

                resolve();
            }
        })
    })
}

const log = (...params) => {
    if (debug) {
        console.log(...params);
    }
}